<a [routerLink]="['/']" class="d-flex align-items-center logo-brand">
  <span class="d-flex align-items-center">
    <img src="/assets/images/logo-white.png" alt="{{ name }}" height="32" />
  </span>
  <h1 style="visibility: hidden">.</h1>
</a>
